const PRODUCT_IMG =
  'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/y34dz1wb_PHOTO-2025-12-24-16-57-25.jpg';

const roboTitan = {
  slug: 'robo-titan',
  name: 'Robo Titan',
  testid: 'titan',
  accent: 'emerald',
  breadcrumb: { label: 'Pool Cleaning Robots', href: '/pool-cleaning-robots' },
  brochureUrl:
    'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/3q72vsgu_Robo%20Titan_Harpalyk_%20Swimming%20Pool%20Cleaning%20Robot_22-06-2026.pdf',
  meta: {
    title: 'Robo Titan - Commercial Swimming Pool Cleaning Robot | Harpalyk',
    description:
      'Robo Titan: high-performance robotic pool cleaner with 350W power, 4 brushless motors, 40,000 L/hour filtration, 20µm filtration, smart Z-navigation, wall & waterline climbing and a 39m cable. Cleans up to 2,500 m² for residential & commercial pools.',
    keywords:
      'Robo Titan, commercial pool cleaning robot, automatic pool cleaner India, robotic pool cleaner, swimming pool robot, large pool cleaner, Harpalyk pool robot',
    canonical: 'https://harpalyk.com/products/robo-titan',
  },
  schema: {
    name: 'Harpalyk Robo Titan Swimming Pool Cleaning Robot',
    description:
      'Robo Titan is a high-performance robotic pool cleaner with 350W power, 4 brushless motors, twin-drive technology, 40,000 L/hour filtration, 20µm ultra-fine filtration, smart Z-pattern navigation, wall & waterline climbing and a 39m tangle-resistant cable. Cleans up to 2,500 m².',
    image: PRODUCT_IMG,
    category: 'Robotic Pool Cleaner',
    price: '450000',
    ratingValue: '4.9',
    reviewCount: '58',
  },
  hero: {
    gradient: 'from-slate-900 via-cyan-900 to-emerald-900',
    badge: 'POOLBOT · Advanced Robotic Pool Cleaner',
    tagline: 'Engineered for a Spotless, Healthier Pool.',
    description:
      'A high-performance robotic pool cleaner built to simplify and automate pool maintenance for large residential and commercial pools — powerful suction, ultra-fine filtration and intelligent navigation.',
    highlights: [
      { label: '2,500 m² Coverage', icon: 'Maximize2' },
      { label: 'Wall & Waterline Clean', icon: 'Waves' },
      { label: '39m Tangle-Free Cable', icon: 'Navigation' },
      { label: '40,000 L/hr Filtration', icon: 'Filter' },
    ],
    galleryAccent: 'emerald',
    galleryBadge: 'Commercial Pool Robot',
  },
  overview: {
    heading: 'Superior Cleaning. Massive Capacity.',
    sub: 'Robo Titan is engineered for the demands of large pools, delivering deep cleaning and crystal-clear water with strong suction, agile movement and spotless results — set it, clean it, enjoy your pool.',
    checklistTitle: 'A Complete, High-Capacity Solution',
    checklist: [
      '4 brushless motors and 8 scrubbing wheels for deep, powerful cleaning',
      'Dual water-pump system filters up to 40,000 litres (40 m³) per hour',
      '4 large debris intake gates for maximum debris collection from all directions',
      'Cleans floor, walls, stairs, coves and the waterline',
      'Suitable for residential and commercial pools on all surfaces',
      'Energy-efficient brushless motors with low operating costs and low noise',
      'No water drainage required — built to last with premium ABS materials',
    ],
    panelGradient: 'from-emerald-50 to-cyan-50',
    stats: [
      { value: '2,500 m²', label: 'Max Coverage' },
      { value: '350 W', label: 'Rated Power' },
      { value: '40,000 L/h', label: 'Filtration Rate' },
      { value: '180 cm', label: 'Wall Climb' },
      { value: '39 m', label: 'Floating Cable' },
      { value: '20 µm', label: 'Filtration' },
    ],
  },
  features: {
    heading: 'Powerful Features for a Spotless Pool',
    items: [
      { icon: 'Cpu', title: '4 Powerful Brushless Motors', description: 'Twin-drive technology with 4 high-performance brushless motors and 8 heavy-duty scrubbing wheels for deep, spotless cleaning.' },
      { icon: 'Navigation', title: 'Smart Z-Pattern Navigation', description: 'Intelligent path planning with S-shape and cross-pattern cleaning ensures complete, systematic coverage of the entire pool.' },
      { icon: 'Waves', title: 'Complete Pool Cleaning', description: 'Cleans floor, walls, stairs, coves and the waterline — climbing walls up to 180 cm high for a truly comprehensive clean.' },
      { icon: 'Filter', title: '20µm Ultra-Fine Filtration', description: 'High-capacity multi-stage filtration with an optional 20µm secondary filter captures algae, dust, sand and fine sediment.' },
      { icon: 'Maximize2', title: '39m Tangle-Resistant Cable', description: 'Extra-long 39m floating cable with anti-twist design for uninterrupted cleaning of large residential and commercial pools.' },
      { icon: 'Shield', title: 'IP68 Waterproof', description: 'Fully sealed underwater protection (IP68 robot, IP26 power control box) for safe, reliable operation.' },
      { icon: 'CalendarClock', title: 'Automatic Scheduling', description: 'Set cleaning times in advance with 3 programmable schedules — Robo Titan auto-starts for worry-free, hands-free cleaning.' },
      { icon: 'Smartphone', title: 'Full-Function Remote', description: 'Handheld remote enables manual navigation and targeted spot cleaning of problem areas with custom cycle settings.' },
      { icon: 'Zap', title: 'Massive 40,000 L/hr Filtration', description: 'Dual water-pump system with 4 large debris intake gates circulates and filters up to 40,000 litres (40 m³) per hour.' },
      { icon: 'Droplets', title: 'Energy Efficient & Water-Saving', description: 'Brushless motors on a safe 29V controller reduce running costs — and no water drainage is required after cleaning.' },
    ],
  },
  sections: [
    {
      type: 'split',
      label: 'Navigation Technology',
      heading: 'Smart Navigation & Precision Cleaning',
      desc: 'An intelligent cleaning program optimizes routes for maximum efficiency and complete coverage, with multiple cleaning patterns and full-function remote control for targeted spot cleaning.',
      itemIcon: 'Navigation',
      items: [
        { title: 'S-Shape Floor Cleaning' },
        { title: 'Cross-Pattern Coverage' },
        { title: 'Wall & Waterline Climbing' },
        { title: 'Spot Cleaning via Remote' },
      ],
      panel: {
        gradient: 'from-cyan-600 to-emerald-700',
        title: 'Built for Large & Commercial Pools',
        desc: 'With a 39m tangle-resistant floating cable and smart Z-pattern navigation, Robo Titan efficiently covers up to 2,500 m² — perfect for hotels, resorts, clubs and large residential pools.',
        subClass: 'text-cyan-100',
        statClass: 'text-emerald-300',
        stats: [
          { value: '2,500', label: 'm² Coverage' },
          { value: '39m', label: 'Floating Cable' },
        ],
      },
    },
    {
      type: 'darkCards',
      label: 'Cleaning Performance',
      heading: 'Superior Cleaning Power',
      sub: 'Four brushless motors, a dual water-pump filtration system and ultra-fine filter bags deliver a deep, thorough clean and noticeably better water quality.',
      cards: [
        { icon: 'Zap', title: 'Powerful Scrubbing & Suction', desc: '4 brushless motors and 8 heavy-duty scrubbing wheels generate ultra-strong suction and traction to pick up debris, dust, sand and microscopic particles.', badge: '4 Motors • 350W' },
        { icon: 'Filter', title: 'Enhanced Filtration', desc: 'A high-capacity multi-stage system filters up to 40,000 L/hour and captures algae, dust, sand and fine sediment down to 20 microns with the optional secondary filter.', badge: 'Down to 20µm' },
        { icon: 'Waves', title: 'Complete Coverage', desc: 'Cleans the floor, walls, stairs, coves and waterline — climbing walls up to 180 cm — for a truly comprehensive clean on residential and commercial pools.', badge: 'Floor • Walls • Waterline' },
      ],
    },
    {
      type: 'listGroups',
      label: 'Versatility',
      heading: 'Suitable for Residential & Commercial Pools',
      groups: [
        { title: 'Pool Types', items: ['Residential Pools', 'Commercial Pools', 'In-Ground Pools', 'Large Format Pools'] },
        { title: 'Pool Surfaces', items: ['Tile', 'Vinyl', 'Gunite', 'Fiberglass'] },
        { title: 'Cleaning Patterns', items: ['S-Shape Floor Cleaning', 'Cross-Pattern Coverage', 'Wall & Waterline Climbing', 'Spot Cleaning via Remote'] },
      ],
    },
    {
      type: 'duoPanels',
      bg: 'gray',
      panels: [
        {
          theme: 'blue',
          icon: 'Shield',
          title: 'Advanced Safety & Self-Protection',
          desc: 'A safe 29V DC low-voltage system and smart protection features keep Robo Titan reliable throughout every cleaning cycle.',
          listIcon: 'RotateCcw',
          list: [
            'Automatically shuts down at the end of the cleaning cycle',
            'Inversion recovery protection rights the unit automatically',
            'Impeller protection system guards against obstructions',
            'Integrated overload protection for reliable operation',
            'Safe 29V DC low-voltage operating system',
          ],
        },
        {
          theme: 'emerald',
          icon: 'CalendarClock',
          title: 'Automatic Scheduling & Savings',
          desc: 'Program cleaning in advance and let Robo Titan handle the rest — efficiently, economically and hands-free.',
          rows: [
            { icon: 'CalendarClock', pre: '', bold: '3 programmable', post: ' cleaning schedules' },
            { icon: 'Timer', pre: '', bold: '4 / 6 / 8 hour', post: ' cycle options' },
            { icon: 'Droplets', pre: '', bold: 'No draining', post: ' required after cleaning' },
          ],
        },
      ],
    },
  ],
  specs: {
    defaultTab: 'general',
    tabs: [
      { id: 'general', label: 'General' },
      { id: 'performance', label: 'Performance' },
      { id: 'filtration', label: 'Filtration & Drive' },
      { id: 'control', label: 'Control & Safety' },
    ],
    data: {
      general: [
        { label: 'Model Name', value: 'Robo-Titan' },
        { label: 'Material', value: 'High-Grade ABS Engineering Plastic' },
        { label: 'Application', value: 'Residential & Commercial' },
        { label: 'Color', value: 'Light Blue' },
        { label: 'Rated Power', value: '350 W' },
        { label: 'Input Voltage', value: '100-220V AC, 50-60 Hz' },
        { label: 'Waterproof Rating', value: 'IP68 Robot / IP26 Box' },
        { label: 'Dimensions (L×W×H)', value: '845.8 × 452.5 × 264 mm' },
        { label: 'Gross Weight (Per Set)', value: '37.5 kg' },
      ],
      performance: [
        { label: 'Max Cleaning Area', value: 'Up to 2,500 m²' },
        { label: 'Cleaning Speed', value: '80-120 m²/hour' },
        { label: 'Moving Speed', value: '15 m/min' },
        { label: 'Water Filtration Rate', value: '40,000 L/hour' },
        { label: 'Water Circulation', value: '40 m³/hour' },
        { label: 'Wall Climbing Height', value: 'Up to 180 cm' },
        { label: 'Cleaning Coverage', value: 'Floor, Walls, Waterline, Stairs & Coves' },
      ],
      filtration: [
        { label: 'Standard Filter Bag', value: '70 µm Fine Filtration' },
        { label: 'Optional Fine Filter', value: '20 µm Ultra-Fine Secondary' },
        { label: 'Filtration Type', value: 'High-Capacity Multi-Stage' },
        { label: 'Debris Intake Gates', value: '4 Large Intake Gates' },
        { label: 'Drive System', value: 'Twin Drive Motor Technology' },
        { label: 'Motors', value: '4 Brushless Motors' },
        { label: 'Scrubbing System', value: '8 Heavy-Duty Wheels' },
        { label: 'Cable Length', value: '39 m Floating Cable' },
      ],
      control: [
        { label: 'Control Method', value: 'Automatic / Remote' },
        { label: 'Cleaning Modes', value: 'Floor / Wall & Floor' },
        { label: 'Cycle Time Options', value: '4 / 6 / 8 Hours' },
        { label: 'Timer Settings', value: '3 Programmable Schedules' },
        { label: 'Scheduling', value: 'Automatic Cleaning Reservation' },
        { label: 'Auto Shut-Off', value: 'Yes' },
        { label: 'Low-Voltage Operation', value: '29V DC Safe System' },
      ],
    },
  },
  contact: {
    heading: 'Ready for a Spotless, Healthier Pool?',
    sub: 'Upgrade to effortless, professional pool cleaning with the Robo Titan. Contact us today for pricing and availability.',
    gradient: 'from-emerald-600 to-cyan-700',
  },
  faqs: [
    {
      question: 'How large a pool can the Robo Titan clean?',
      answer:
        'The Robo Titan is built for big jobs — it cleans up to 2,500 m² at a speed of 80-120 m²/hour, making it ideal for both large residential pools and commercial pools in hotels, resorts and clubs. Its 39m floating, tangle-resistant cable provides extended reach across large pool areas.',
    },
    {
      question: 'How powerful is the cleaning and filtration?',
      answer:
        'Robo Titan uses 4 brushless motors with twin-drive technology and 8 heavy-duty scrubbing wheels. A dual water-pump system with 4 large debris intake gates filters up to 40,000 litres (40 m³) per hour, capturing leaves, dirt, hair, algae and fine particles down to 20 microns with the optional ultra-fine filter.',
    },
    {
      question: 'Does it clean walls and the waterline?',
      answer:
        'Yes. With twin-drive motors and smart Z-pattern navigation (S-shape and cross-pattern), Robo Titan cleans the floor, walls, stairs, coves and waterline, climbing walls up to 180 cm high for complete, systematic coverage.',
    },
    {
      question: 'Can I schedule cleaning automatically?',
      answer:
        'Absolutely. Robo Titan offers automatic scheduling with 3 programmable cleaning reservations and cycle options of 4, 6 or 8 hours. Set your cleaning times in advance and it will auto-start — set it, clean it, enjoy your pool. A full-function handheld remote is also included for manual and spot cleaning.',
    },
    {
      question: 'Is it safe and energy efficient?',
      answer:
        'Yes. Robo Titan runs on a safe 29V DC low-voltage system with brushless motor technology for low running costs. Built-in safety features include auto shut-off, inversion recovery, impeller protection and integrated overload protection. No water drainage is required after cleaning.',
    },
  ],
  related: [
    { label: 'All Pool Robots', href: '/pool-cleaning-robots' },
    { label: 'Robo Dressel', href: '/products/robo-dressel' },
    { label: 'HygienX 300', href: '/products/hygienx-300' },
    { label: 'Window Cleaning Robots', href: '/window-cleaning-robots' },
    { label: 'View All Products', href: '/#products' },
  ],
};

export default roboTitan;
